<template>
	<div class="m-1">
		<b-modal ref="repaytip-modal" size="sm" id="modal-center" centered hide-footer  hide-title
			title="提示">
			<div>
				<div>
					抱歉，由于系统调整，请还款至：
				</div>
				<div>
					上海信而富信息科技有限公司，
				</div>
				<div>
					账号：644605725，
				</div>
				<div>
					支行：民生银行崇明支行。
				</div>
				<div>
					还款成功后请把汇款回执发给还款专员，谢谢！
				</div>	
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		components: {
		},
		data() {
			return {
			
			}
		},

		methods: {
			showModal() {
			
				this.$refs['repaytip-modal'].show()
			
			},
		
			hideModal() {
				this.$refs['repaytip-modal'].hide()
			},
		}

	}
</script>

<style>

</style>
